;(function ($) {

    /**
     * SO these controls don't share across mobile and desktop, just leaving them attached works fine
     *
     */

    // Open/ Close Mobile Menu
    $("#header_menu_trigger").on('click', function (ev) {
        ev.preventDefault();
        $(".main-menu-container, .secondary-nav-container").toggleClass('menu-open');
        $("#header_menu_trigger").toggleClass('menu-open');
        $("#header_menu_trigger").attr('aria-expanded', $("#header_menu_trigger").hasClass('menu-open'));
    });

    // Open Close mobile Search panel
    $("#header_search_trigger_mobile").on('click', function (ev) {
        ev.preventDefault();
        $("#heading_search_panel").toggleClass('menu-open');
        $("#header_search_trigger_mobile").toggleClass('menu-open');
        $("#header_search_trigger_mobile").attr('aria-expanded', $("#header_search_trigger_mobile").hasClass('menu-open'));
    });

    // Open Close Desktop search panel
    $("#header_search_trigger_desktop").on('click', function (ev) {
        ev.preventDefault();
        $("#heading_search_panel").toggleClass('menu-open');
        $("#header_search_trigger_desktop").toggleClass('menu-open');
        $("#header_search_trigger_desktop").attr('aria-expanded', $("#header_search_trigger_desktop").hasClass('menu-open'));
    });

    // Open Close Desktop search panel
    $("#header_translation_trigger_desktop").on('click', function (ev) {
        ev.preventDefault();
        $("#header_translation_panel").toggleClass('menu-open');
        $("#header_translation_trigger_desktop").toggleClass('menu-open');
        $("#header_translation_trigger_desktop").attr('aria-expanded', $("#header_search_trigger_desktop").hasClass('menu-open'));
    });


    const MENU_CONTAINER_SELECTOR = '#main_menu_container';

    $(MENU_CONTAINER_SELECTOR + ' .menu-item-has-children').attr('aria-expanded', false);
    $(MENU_CONTAINER_SELECTOR + ' .menu-item-has-children').attr('aria-haspopup', true);


    $(MENU_CONTAINER_SELECTOR).on('click', 'a', function (ev) {

        if (!$(this).closest('.menu-item').hasClass('menu-item-has-children')) return true;
        ev.preventDefault();

        $(MENU_CONTAINER_SELECTOR + ' .menu-item').not($(this).parents('.menu-item')).removeClass('menu-open');
        $(MENU_CONTAINER_SELECTOR + ' .menu-item').not($(this).parents('.menu-item')).attr('aria-expanded', false);

        if ($(this).closest('.menu-item').hasClass('menu-open')) {
            $(this).closest('.menu-item').removeClass('menu-open');
            $(this).closest('.menu-item').attr('aria-expanded', false);
            $(this).closest('.menu-item').find('menu-open').removeClass('menu-open');
            $(this).closest('.menu-item').find('menu-open').attr('aria-expanded', false);;
        } else {
            $(this).closest('.menu-item').addClass('menu-open');
            $(this).closest('.menu-item').attr('aria-expanded', true);
        }

    });

    // Shrink header on scroll
    $(window).scroll(function() {
        if ($(document).scrollTop() > 0) {
            $('.header-site-wide').addClass('shrink');
        } else {
            $('.header-site-wide').removeClass('shrink');
        }
    });
    
    const $menu = $('.sub-menu');

    $(document).mouseup(function (e) {
        if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
            $(".main-menu li").removeClass('menu-open');
        }
    });

})(jQuery);